import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { TickerInterval, TickerService } from '@frontend/sports/common/core/utils/timer';
import { Subscription } from 'rxjs';

import { TimerUtilsService } from '../../timers/timer-utils.service';

@Component({
    selector: 'ms-scoreboard-timer',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScoreboardTimerComponent implements OnChanges, OnDestroy {
    @Input() event: EventModel;
    @HostBinding('class') className = 'scoreboard-timer';
    @HostBinding() innerHtml: string;

    private tickerSubscription: Subscription;

    constructor(
        private ticker: TickerService,
        private changeDetector: ChangeDetectorRef,
        private timerUtilsService: TimerUtilsService,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.stopSubscription();

        this.setTime();
        this.tickerSubscription = this.ticker.subscribe(this.setTime, TickerInterval.Second);
    }

    ngOnDestroy(): void {
        this.stopSubscription();
    }

    private stopSubscription(): void {
        this.tickerSubscription?.unsubscribe();
    }

    private setTime = () => {
        const format = this.timerUtilsService.getEventStartingInFullText(this.event.startDate.getTime());

        if (format === this.innerHtml) {
            return;
        }
        this.innerHtml = format;
        this.changeDetector.markForCheck();
    };
}
